module.exports = __webpack_public_path__ + "assets/img/qudao.1307687f.png";